// extracted by mini-css-extract-plugin
module.exports = {"root":"Ku7EW","bg":"OHLEB"};